"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _reactRedux = require("react-redux");
var _underscore = require("underscore");
var _getSourcesInProgram = require("@studio/sources/getSourcesInProgram");
var _checkSourceTypes = require("@studio/sources/checkSourceTypes");
var _queueSceneLayoutSelector = require("@studio/program/sceneLayout/queueSceneLayoutSelector");
var _Sources = require("@studio/constants/Sources");
var _SceneLayouts = require("@studio/constants/SceneLayouts");
var _queueStageLayout = _interopRequireDefault(require("../program/queueStageLayout"));
var _types = require("./types");
var _notification = require("../notification");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function toggleStageSource(source) {
  return function (dispatch, getState) {
    var _getState = getState(),
      broadcastSources = _getState.broadcastSources.sources,
      _getState$stagedSourc = _getState.stagedSources,
      currentlyStagedSources = _getState$stagedSourc.sources,
      stagedSceneLayout = _getState$stagedSourc.sceneLayout;
    var stagedSources = _objectSpread({}, currentlyStagedSources || {});
    var sourceId = source._id,
      sourceType = source.type;

    // Are we trying to add the source to the list of staged sources?
    var isStaged = stagedSources[sourceId];

    // If we're staging the source, and we'll exceed the limit we show the
    // notification and return. If we're not staging we're un-staging the
    // source. We should not attempt to enforce the limit in this case.
    if (!isStaged && Object.keys(stagedSources).length >= _SceneLayouts.CAMERA_PRESENTER_LIMIT) {
      return dispatch((0, _notification.showNotification)("You're at the max of ".concat(_SceneLayouts.CAMERA_PRESENTER_LIMIT, " sources available at a time on stage."), {
        timeout: 3500,
        type: 'alert'
      }));
    }
    var isAudioSource = sourceType === _Sources.AUDIO_FILE;
    var stagedSourceIds = Object.keys(stagedSources).filter(function (sourceId) {
      return stagedSources[sourceId];
    });
    var _getVisualMediaSource = (0, _getSourcesInProgram.getVisualMediaSourcesInProgram)(stagedSourceIds, broadcastSources),
      _getVisualMediaSource2 = _slicedToArray(_getVisualMediaSource, 1),
      stagedVisualMediaSource = _getVisualMediaSource2[0];
    var isVisualMediaSourceStaged = !(0, _underscore.isEmpty)(stagedVisualMediaSource);

    // replace staged visual media source w/ the new visual media source
    if (isVisualMediaSourceStaged && (0, _checkSourceTypes.isVisualMediaSource)(source) && !isStaged) {
      // un stage previous visual media source
      delete stagedSources[stagedVisualMediaSource._id];
      stagedSources[sourceId] = true;
    } else {
      stagedSources[sourceId] = !isStaged;
    }
    if (stagedSources[sourceId] === false) {
      delete stagedSources[sourceId];
    }

    /**
     * Since AUDIO_FILE should NOT change scene layout,
     * when selected, we just return previously selected layout
     * so UI does not change.
     */
    var sceneLayout = isAudioSource ? stagedSceneLayout : (0, _queueSceneLayoutSelector.queueSceneLayoutSelector)(stagedSources, broadcastSources);
    var action = {
      type: _types.BROADCAST_TOGGLE_STAGE_SOURCE,
      payload: stagedSources
    };
    (0, _reactRedux.batch)(function () {
      dispatch(action);
      dispatch((0, _queueStageLayout["default"])(sceneLayout));
    });
  };
}
var _default = exports["default"] = toggleStageSource;